(function(){
    'use strict'

    angular.module('app.organizadores')
    .factory('OrganizadoresService', OrganizadoresService);

    OrganizadoresService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function OrganizadoresService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update: update,
            remove: remove
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/organizadores';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(organizadorId){

            var url = apiSettings.apiBaseUrl + 'api/organizadores/' + organizadorId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(organizador){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/organizadores',  
                method: 'POST',  
                data: organizador
            });  
            return response;
        };

        function update(organizador){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/organizadores',  
                method: 'PUT',  
                data: organizador
            });  
            return response;
        };

        function remove(organizador){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/organizadores',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: organizador
            });  
            return response;
        };

    };

})();